
import StoryBlokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryBlokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      if (this.blok?.autoColumns) {
        styles.gridTemplateColumns = `repeat(${this.getBreakpointValue(
          this.blok?.autoColumns
        )}, minmax(0, 1fr))`
      } else if (this.blok.templateColumns) {
        styles.gridTemplateColumns = this.buildGridTemplateColumns(
          this.getBreakpointValue(this.blok?.templateColumns)
        )
      }

      styles.flexDirection = this.getBreakpointValue(this.blok.flexDirection)
      styles.justifyContent = this.getBreakpointValue(this.blok.justifyContent)
      styles.placeSelf = this.getBreakpointValue(this.blok.placeSelf)
      styles.placeItems = this.getBreakpointValue(this.blok.placeItems)
      styles.justifyItems = this.getBreakpointValue(this.blok.justifyItems)
      styles.gap = this.getBreakpointValue(this.blok?.gap)
      styles.alignItems = this.getBreakpointValue(this.blok.alignItems)
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.maxWidth = this.getBreakpointValue(this.blok.maxWidth)
      styles.boxShadow = this.getBreakpointValue(this.blok.boxShadow)

      return styles
    },
  },
  methods: {
    buildGridTemplateColumns(sizes) {
      if (!sizes) return null

      const columnSizes = sizes
        .replace(/\s/g, '')
        .split(',')
        ?.reduce((acc, next) => {
          return acc + ` ${next}fr`
        }, '')
      return columnSizes
    },
  },
}
